export const match = (param: string) => param === 'preview';
